import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest, sendPostRequest } from '../../../api/requestUtil';


export const fetchNotifications = createAsyncThunk<
  NotificationType[], // What the thunk successfully returns (payload for fulfilled action)
  void, // Argument passed to the thunk (none)
  {
    state: AppState; // Type for `getState`
    rejectValue: string; // Type for `rejectWithValue`
  }
>(
  'notifications/fetchNotifications', // Action type prefix
  async (_, { getState, rejectWithValue }) => {
    // No `dispatch` here yet, as per request
    const state = getState() as AppState;
    const isLoggedIn = state.user.isLoggedIn;
    const token = state.user.authToken;

    if (!token || !isLoggedIn) {
      return rejectWithValue('Not authenticated. Please log in.');
    }

    try {
      const response: NotificationType[] = await sendGetRequest(
        `/api/notifications/`,
        token
      );
      return response;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.detail ||
        error?.message ||
        'An unknown error occurred while fetching notifications';
      console.error('Error fetching notifications:', error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const markNotificationsRead = createAsyncThunk<
  number[],
  number[],
  {
    state: AppState;
    rejectValue: string;
  }
>(
  'notifications/markNotificationsRead',
  async (notificationIds: number[], { getState, rejectWithValue }) => {
    const state = getState() as AppState;
    const token = state.user.authToken;
    if (!token) {
      return rejectWithValue('Authentication token missing.');
    }
    if (!notificationIds || notificationIds.length === 0) {
      return rejectWithValue('No notification IDs provided to mark as read.');
    }
    try {
      await sendPostRequest(
        `/api/notifications/mark-viewed/`,
        { ids: notificationIds },
        token
      );
      return notificationIds;
    } catch (error: any) {
      const errorMessage =
        error?.detail ||
        error?.message ||
        'Failed to mark notifications as read.';
      console.error('Error marking notifications as read:', error);
      return rejectWithValue(errorMessage);
    }
  }
);
